/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import {Row, Col, Box, Button, Pagination} from 'adminlte-2-react';
import Loader from '../utils/Loader';
import {Alert} from '../ui/alert';
import {
  getDateUtc,
  submitSearchOnEnterPress,
  toTitleCase,
} from '../utils/utils';
import {TextInput} from '../utils/TextInput';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {ButtonWithLoading} from '../utils/ButtonWithLoading';
import {ModalGenerico} from '../ui/ModalGenerico';
import {Content} from '../ui/Content';
import {useWindowSize} from '../utils/useWindowSize';

export const FeriadosListView = ({
  history,
  topAlert,
  submitAlert,
  totalResults,
  page,
  pageSize,
  handlePage,
  lista,
  busquedaRapida,
  setBusquedaRapida,
  feriadosGet,
  doDeleteFeriado,
  feriadoDelete,
  selected,
  setSelected,
  isDeleteConfirmModalShown,
  setIsDeleteConfirmModalShown,
}) => {
  const {isMobile} = useWindowSize();

  return (
    <Content title="Feriados" history={history}>
      {topAlert.text && (
        <Alert
          title={topAlert.title}
          type={topAlert.type}
          text={topAlert.text}
          closable={topAlert.closable}
        />
      )}

      {selected && (
        <ModalGenerico
          isModalShown={isDeleteConfirmModalShown}
          hideModal={() => setIsDeleteConfirmModalShown(false)}
          title="Eliminar"
          body="Se eliminará el feriado. ¿Continuar?"
          buttonText="Eliminar"
          buttonType="danger"
          buttonDisabled={!selected}
          buttonLoading={feriadoDelete.loading}
          submit={doDeleteFeriado}
        />
      )}

      <Row>
        <Col md="10" mdOffset="1">
          <Box title="Filtro">
            <Col md="3">
              <TextInput
                label="Búsqueda rápida"
                placeholder="Nombre"
                initialValue={busquedaRapida}
                setValue={setBusquedaRapida}
                onKeyDown={evt =>
                  submitSearchOnEnterPress(evt, () => handlePage(1))
                }
              />
            </Col>
            <Col md="12">
              <div style={{float: 'right'}}>
                <div style={{display: 'inline-block', marginRight: 10}}>
                  <Button
                    type="primary"
                    text="Filtrar"
                    onClick={() => handlePage(1)}
                  />
                </div>
              </div>
            </Col>
          </Box>
        </Col>
        <Col md="10" mdOffset="1">
          <Box
            title="Lista"
            customOptions={
              <div>
                <Button
                  size="sm"
                  type="default"
                  text="Agregar"
                  onClick={() => history.push('/feriado/crear')}
                />
              </div>
            }>
            <div style={{display: 'block'}}>
              <span>Total: {totalResults}</span>
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                justifyContent: 'space-between',
              }}>
              <div>
                <Pagination
                  activePage={page - 1}
                  pageSize={pageSize}
                  totalElements={totalResults}
                  onChange={page => handlePage(page + 1)}
                  labels={{
                    first: 'Primera',
                    last: 'Última',
                    previous: 'Anterior',
                    next: 'Siguiente',
                  }}
                />
              </div>
            </div>

            <Loader isLoading={feriadosGet.loading}>
              {lista && lista.length > 0 ? (
                <Box noPadding={true} border={false} style={{borderTop: 0}}>
                  <div className="table-responsive">
                    <DataTable
                      lazy
                      pt={{
                        table: {
                          className: 'table table-hover',
                        },
                      }}
                      value={lista}
                      emptyMessage="No se encontraron registros">
                      <Column
                        field="nombre"
                        header="Nombre"
                        body={feriado => toTitleCase(feriado.nombre)}
                      />

                      <Column
                        field="fecha"
                        header="Fecha"
                        body={feriado => getDateUtc(feriado.fecha)}
                      />

                      <Column
                        field="eliminar"
                        header="Eliminar"
                        body={feriado => (
                          <div style={{}}>
                            <div style={{display: 'inline-block'}}>
                              <ButtonWithLoading
                                type="warning"
                                size="sm"
                                text="Eliminar"
                                submit={() => {
                                  setSelected(feriado);
                                  setIsDeleteConfirmModalShown(true);
                                }}
                              />
                            </div>
                          </div>
                        )}></Column>
                    </DataTable>
                  </div>
                </Box>
              ) : (
                <h4>No se han encontrado feriados</h4>
              )}
            </Loader>
            <Pagination
              activePage={page - 1}
              pageSize={pageSize}
              totalElements={totalResults}
              onChange={page => handlePage(page + 1)}
              labels={{
                first: 'Primera',
                last: 'Última',
                previous: 'Anterior',
                next: 'Siguiente',
              }}
            />
            <div>
              <span>Total: {totalResults}</span>
            </div>

            {submitAlert.text && (
              <Alert
                title={submitAlert.title}
                type={submitAlert.type}
                text={submitAlert.text}
                closable={submitAlert.closable}
              />
            )}
          </Box>
        </Col>
      </Row>
    </Content>
  );
};
